import _Object$assign from 'babel-runtime/core-js/object/assign';
import parseField from './convertFieldProperty';
function matchOrderType(item) {
  if (item.code.indexOf('kvstore') > -1) {
    return true;
  }
  return item.show;
}
//处理配件字段，一个配件可能会包含多个可显示的属性
export default function convertFields(item) {
  //处理配件
  var fields = [];
  var _item$components = item.components,
      components = _item$components === undefined ? [] : _item$components;


  for (var key in components) {
    var com = _Object$assign({}, components[key]);
    var properties = com.properties;
    var convertedProperties = {};

    //处理配件的属性
    for (var propertyCode in properties) {
      var property = properties[propertyCode];
      var convertedProperty = parseField(property, propertyCode, item);
      if (matchOrderType(convertedProperty)) {
        convertedProperties[propertyCode] = convertedProperty;
      }
    }
    com.properties = convertedProperties;
    fields.push(com);
  }
  return fields;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertField/index.js
// module id = 177
// module chunks = 0